// extracted by mini-css-extract-plugin
export default {"videoResponsive":"YoutubeEmbed_videoResponsive__n2XdX"};